import { render, staticRenderFns } from "./Medicalresourceslist.vue?vue&type=template&id=7055a31f&"
import script from "./Medicalresourceslist.vue?vue&type=script&lang=js&"
export * from "./Medicalresourceslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports